import CreateEditPrivacyPolicyTemplate from "@/app/app-shared/privacy-policy/create-edit-privacy-policy-template";
import PageHeader from "@/app/shared/page-header";
import { routes } from "@/config/routes";
import { SITE_CONTENT_TYPES } from "@/config/constants";
import { ESiteContentType } from "@/utilities/enums/SiteContent";
import { useParams } from "react-router-dom";

export default function SystemSiteContentPage() {
  const { contentType = ESiteContentType.CONTACT_US } = useParams();
  const type = contentType as ESiteContentType;
  const title = SITE_CONTENT_TYPES[type]?.label || contentType;

  return (
    <div className="@container h-full mt-10">
      <PageHeader
        title={title}
        breadcrumb={[
          { href: routes.siteContent.listing, name: "Pages" },
          { name: title },
        ]}
      />
      <CreateEditPrivacyPolicyTemplate
        contentType={type}
        pageTitle={title}
      />
    </div>
  );
}
